import { toggleDeactivationReason } from './../../../../config/redux/clients/clientsActions';
import { setListMessage } from './../../../../config/redux/alerts/alertsActions';
import { toggleClientsPanel, toggleEditing } from './../../../../config/redux/clients/panel/clientPanelActions';
import { getOrderTypes } from './../../../../connectors/orderTypes/connectors/index';
import { useQuery } from 'react-query';
import { setErrorAlert } from '../../../../config/redux/alerts/alertsActions';
import { useEffect } from "react";
import { useSelector, RootStateOrAny, useDispatch } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import { checkQuantity } from "../../actions/checkQuantity";
import { NavigationPath } from "../../../../config/routing/NavigationPath";
import { generateUnverifiedcommands } from "../../actions/generateCommands/clients/generateUnverifiedCommands";
import { generateActivecommands } from "../../actions/generateCommands/clients/generateActiveCommands";
import { generateInActivecommands } from "../../actions/generateCommands/clients/generateInactiveCommands";
import { ClientsAlerts } from "../../../clients/models/clientsAlerts.enum"

import {
  reloadData,
  clearListData,
  toggleAddComapnyPanel,
} from "../../../../config/redux/clients/clientsActions";
import { clearFilters } from "../../../../config/redux/filters/filterActions";
import {
  setUserAsActive,
  verifyCompany,
  deleteCompany,
  getActiveCompaniesReport,
  getInactiveCompaniesReport, setUserAsInActive
} from "../../../../connectors/clients/connectors";

const message = "Operacja przebiegła pomyślnie"

export const useClientsCommandBar = () => {
  const { selectedClients } = useSelector(
    (state: RootStateOrAny) => state.clients
  );
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const quantity = checkQuantity(selectedClients.length);

  const addCompany = () => {
    dispatch(toggleAddComapnyPanel({ isOpen: true }));
  };



  const activate = async () => {
    try{
      setUserAsActive(selectedClients[0]);
      dispatch(reloadData({ reload: true }));
    }catch(err){
      console.error(err)
    }
  };

  const deactivate = async () => {
    setUserAsInActive(selectedClients[0]);
    dispatch(reloadData({ reload: true }));
  };

  const edit = () => {
    dispatch(toggleClientsPanel(true))
    dispatch(toggleEditing({editing: true}))
  }

  const see = () => {
    dispatch(toggleClientsPanel(true))
  }

  const verify = async (e: any) => {
    try{
      const data = {
        companiesIds: selectedClients,
        orderTypeId: e.currentTarget.id,
      };
      await verifyCompany(data);
      dispatch(reloadData({ reload: true }));
      dispatch(setListMessage(message))
    }catch(err){
      dispatch(setErrorAlert(ClientsAlerts.CHOSE_ORDER_TYPE))
    }  
  };

  useEffect(() => {
    const unlisten = history.listen(() => {
      dispatch(clearListData());
      dispatch(clearFilters());
    });

    return () => {
      unlisten();
    };
  }, []);

  const {data} = useQuery("orderTypesToVerify", getOrderTypes)

  const _generateItems = () => {
    const { pathname } = location;
    switch (pathname) {
      case NavigationPath.UNVERIFIED_CLIENTS:
        const actions = {
          verify,
          edit,
          see 
        };
        return generateUnverifiedcommands(quantity, actions, data ? data.data.data : []);
      // case NavigationPath.NEW_CLIENTS:
      //   return generateNewcommands(quantity, {
      //     addCompany,
      //     deactivate,
      //     removeCompany,
      //     edit
      //   });
      case NavigationPath.ACTIVE_CLIENTS:
        return generateActivecommands(quantity, {
          deactivate,
          edit,
          see,
          //uploadFiles
        });

      case NavigationPath.INACTIVE_CLIENTS:
        return generateInActivecommands(quantity, {
          activate,
          edit,
          see,
        });
      default:
        return [];
    }
  };

  const items = _generateItems();

  return {
    items,
  };
};